import * as React from "react";
import { equals } from "..";
import { ErrorLayout } from "./ErrorBoundary.layout";
export class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { error: undefined };
        this.resetState = (goHome = false) => {
            if (goHome) {
                return void (window.location.href = "/");
            }
            this.setState({ error: null });
            if (this.props.onErrorReset) {
                this.props.onErrorReset();
            }
            // TODO implement goHome
        };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidUpdate(prevProps) {
        if (this.state.error &&
            this.props.dependencies &&
            prevProps.dependencies &&
            !equals(prevProps.dependencies, this.props.dependencies)) {
            this.setState({ error: null });
        }
    }
    componentDidCatch(error, info) {
        // console.error("ErrorBoundary error", error);
        // console.error("ErrorBoundary info", info);
    }
    render() {
        var _a;
        if (this.state.error) {
            // You can render any custom fallback UI
            return (React.createElement(ErrorLayout, { reset: this.resetState },
                React.createElement("h1", null, "Error"),
                ((_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message) && React.createElement("h2", null, this.state.error.message)));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map